<template>
  <div id='ykEditor'>
    <ckeditor id='ckeditor'
              :editor='editor'
              v-model='editorData'
              :config='editorConfig' @ready='onReady'></ckeditor>
  </div>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue2'
import '@ckeditor/ckeditor5-build-decoupled-document/build/translations/zh-cn'
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document'
import MyUploadAdapter from '@/utils/MyUploadAdapter'

export default {
  name: 'ClassicEditor',
  components: {
    //局部注册方式
    ckeditor: CKEditor.component
  },
  model: {
    prop: 'content',//指向props的参数名
    event: 'change'//事件名称
  },
  props: {
    content: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入内容'
    }
  },
  watch: {
    content(val) {
      this.editorData = val
    },
    editorData(val) {
      this.$emit('change', val)
      this.$emit('update:content', val)
    },
    deep: true
  },
  data() {
    return {
      editor: DecoupledEditor,
      editorData: this.content,
      editorConfig: {
        toolbar: [
          'heading',
          '|',
          'fontfamily',
          'fontsize',
          'fontColor',
          'fontBackgroundColor',
          '|',
          'bold',
          'italic',
          'underline',
          'strikethrough',
          '|',
          'alignment',
          '|',
          'numberedList',
          'bulletedList',
          '|',
          'indent',
          'outdent',
          '|',
          'link',
          'blockquote',
          'imageUpload',
          'insertTable',
          'mediaEmbed',
          '|',
          'undo',
          'redo'
        ],
        placeholder: this.placeholder,
        language: 'zh-cn'
      },
      loader: null
    }
  },
  methods: {
    getContent() {
      return this.editorData
    },
    setContent(val) {
      this.editorData = val
    },
    onReady(editor) {
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
        editor.ui.view.toolbar.element,
        editor.ui.getEditableElement()
      )
      // 自定义上传图片插件
      editor.plugins.get('FileRepository').createUploadAdapter = loader => {
        return new MyUploadAdapter(loader)
      }
    }
  }

}
</script>

<style lang='less' scoped>
/deep/ .ck-editor__editable {
  min-height: 400px;
}

/deep/ .ck-body-wrapper {
  /deep/ .ck-balloon-panel {
    z-index: 9999 !important;
  }
}
</style>

